import React, { useState } from "react";
import {
  useGridApiContext,
  gridFilterModelSelector,
  GridFilterPanel,
} from "@mui/x-data-grid-pro";
import SaveUserFilter from "./SaveUserFilter";
import { Select, MenuItem, IconButton, Box, Button } from "@mui/material";
import CopyBox from "../../MessageBox/CopyBox";
import { useSelectedFilterContext } from "../../../Context/GridEquipListContext";
export default function CustomFilterPanel(props) {
  const apiRef = useGridApiContext();
  const itemSelectedFilter = useSelectedFilterContext();
  const {
    onApply,
    filterProperty,
    localization,
    onFilterSave,
    saveFilterlist,
    reportCode,
    tableData,
    apiRefFilter,
  } = props;
  // const [isFilterHasValue, setIsFilterHasValue] = React.useState(false);

  let isFilterHasValue = false;
  const filterModel = gridFilterModelSelector(apiRef.current.state).items;
  if (filterModel && Array.isArray(filterModel)) {
    isFilterHasValue = filterModel.some(
      (item) =>
        item.operator === "isEmpty" ||
        (item.value !== undefined && item.value !== ""),
    );
  }

  function handleFilterValue(_key) {
    const filterModel = gridFilterModelSelector(apiRef.current.state);
    if (_key === "save") {
      onFilterSave(_key, filterModel, itemSelectedFilter);
    } else {
      onApply(_key, filterModel);
    }
  }

  return (
    <>
      <Box>
        {/* Add the heading */}

        {/* Render the default filter panel */}
        <GridFilterPanel {...tableProperty} />

        <Box
          style={{
            padding: "10px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "end" }}>
            <SaveUserFilter
              saveFilterlist={saveFilterlist}
              reportCode={reportCode}
              tableData={tableData}
              apiRef={apiRef}
            />
          </Box>
          <Box>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                apiRef.current.setFilterModel({ items: [] });
                onApply("reset", []);
              }}
              className="mr-2"
            >
              {localization.reset}
            </Button>
            <Button
              className="mr-2"
              variant="contained"
              color="primary"
              onClick={() => {
                handleFilterValue("save");
              }}
              disabled={!isFilterHasValue}
            >
              {localization.save}
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                handleFilterValue("apply");
              }}
              disabled={!isFilterHasValue}
            >
              {localization.apply}
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  );
}

let tableProperty = {
  columnsSort: "asc",
  filterFormProps: {
    logicOperators: [],
    logicOperatorInputProps: {
      variant: "outlined",
      size: "small",
    },
    columnInputProps: {
      variant: "outlined",
      size: "small",
      sx: { mt: "auto" },
    },
    operatorInputProps: {
      variant: "outlined",
      size: "small",
      sx: { mt: "auto" },
    },
    valueInputProps: {
      InputComponentProps: {
        variant: "outlined",
        size: "small",
      },
    },
    deleteIconProps: {
      sx: {
        "& .MuiSvgIcon-root": { color: "#d32f2f" },
      },
    },
  },
  sx: {
    // Customize inputs using css selectors
    "& .MuiDataGrid-filterForm": { p: 2 },
    "& .MuiDataGrid-filterForm:nth-child(even)": {
      backgroundColor: (theme) =>
        theme.palette.mode === "dark" ? "#444" : "#f5f5f5",
    },
    "& .MuiDataGrid-filterFormLogicOperatorInput": { mr: 2 },
    "& .MuiDataGrid-filterFormColumnInput": { mr: 2, width: 150 },
    "& .MuiDataGrid-filterFormOperatorInput": { mr: 2 },
    "& .MuiDataGrid-filterFormValueInput": { width: 200 },
  },
};
